import React from 'react'
import { WalletOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { isNil } from 'lodash'

const Wallet = () => {
  const { data: balance } = useSelector(s => s.wallet)

  if (isNil(balance)) {
    return null
  }

  return (
    <>
      <WalletOutlined type="wallet" className="text-muted" style={{ fontSize: 16 }} />
      <span className="ml-2">{balance} ron</span>
    </>
  )
}

export default Wallet
